module.exports = __webpack_public_path__ + "static/img/logo.89b13f2d.svg";